module.exports = __webpack_public_path__ + "img/success-circle.92b42a2a.svg";